// Branch seed/demo data. Phones + WhatsApp numbers and locations are from the
// printed menu. Coordinates are APPROXIMATE placeholders — confirm exact branch
// pins with the client. Delivery pricing uses the plan defaults (§3): distance ×
// order-size matrix, 3.000 KWD minimum, 0.500 KWD floor, ~12 km reach.
//
// serviceAreas map each Kuwait area to a distance band so a customer can pick their
// area manually (no map pin needed). Bands are rough — confirm with the client.
import type { Branch, BranchPricing } from "../lib/types";

const DEFAULT_PRICING: BranchPricing = {
  minOrder: 3,
  feeFloor: 0.5,
  maxDistanceKm: 12,
  roadFactor: 1.3,
  distanceBands: [4, 8, 12],
  sizeTiers: [
    { min: 0, max: 7 },
    { min: 7, max: 15 },
    { min: 15, max: null },
  ],
  feeMatrix: [
    [1.0, 0.75, 0.5],
    [1.5, 1.25, 1.0],
    [2.0, 1.75, 1.5],
  ],
};

export const BRANCHES_SEED: Branch[] = [
  {
    id: "salmiya",
    name: "Salmiya",
    nameAr: "السالمية",
    // Block 10, Street Yusuf Al-Badar, Marfie Building (opp. Kuwait English Academy).
    lat: 29.3375,
    lng: 48.0685,
    phone: "+96523919467",
    whatsapp: "+96560062930",
    active: true,
    addressEn: "Block 10, Street Yusuf Al-Badar, Marfie Building — opposite Kuwait English Academy, Salmiya",
    addressAr: "قطعة 10، شارع يوسف البدر، مبنى مرفيه — مقابل الأكاديمية الإنجليزية، السالمية",
    hours: "Daily · 11:00 AM – 1:00 AM",
    hoursAr: "يومياً · 11 ص – 1 ص",
    serviceAreas: [
      { en: "Salmiya", ar: "السالمية", band: 0 },
      { en: "Hawally", ar: "حولي", band: 0 },
      { en: "Rumaithiya", ar: "الرميثية", band: 0 },
      { en: "Shaab", ar: "الشعب", band: 0 },
      { en: "Bayan", ar: "بيان", band: 1 },
      { en: "Salwa", ar: "سلوى", band: 1 },
      { en: "Jabriya", ar: "الجابرية", band: 1 },
      { en: "Mishref", ar: "مشرف", band: 1 },
      { en: "Kuwait City", ar: "مدينة الكويت", band: 2 },
    ],
    pricing: DEFAULT_PRICING,
  },
  {
    id: "fahaheel",
    name: "Fahaheel",
    nameAr: "الفحيحيل",
    // Al-Dabbous Street, Mazyed Al-Otaibi Complex (Red Tag), Ground Floor.
    lat: 29.0825,
    lng: 48.1319,
    phone: "+96523913668",
    whatsapp: "+96569954870",
    active: true,
    addressEn: "Al-Dabbous Street, Mazyed Al-Otaibi Complex (Red Tag), Ground Floor, Fahaheel",
    addressAr: "شارع الدبوس، مجمع مزيد العتيبي (ريد تاغ)، الطابق الأرضي، الفحيحيل",
    hours: "Daily · 11:00 AM – 1:00 AM",
    hoursAr: "يومياً · 11 ص – 1 ص",
    serviceAreas: [
      { en: "Fahaheel", ar: "الفحيحيل", band: 0 },
      { en: "Mangaf", ar: "المنقف", band: 0 },
      { en: "Dhaher", ar: "الظهر", band: 0 },
      { en: "Mahboula", ar: "المهبولة", band: 1 },
      { en: "Abu Halifa", ar: "أبو حليفة", band: 1 },
      { en: "Fintas", ar: "الفنطاس", band: 1 },
      { en: "Riqqa", ar: "الرقة", band: 1 },
      { en: "Sabahiya", ar: "الصباحية", band: 1 },
      { en: "Ahmadi", ar: "الأحمدي", band: 2 },
    ],
    pricing: DEFAULT_PRICING,
  },
];
